// check if there is a localStorage 'prevPage' set
// if no, breadcrumb should just be homepage,
// if yes, check that the the value matches the previous page
// also check that the breadcrumb doesn't already exist on the page (ie, if it was in the url)
// if it does match the previous page, set the breadcrumb to be that value, clear the storage item
// if it doesn't match the previous page, breadcrumb should just be homepage, clear the value

if (localStorage.getItem("prevPage")) {
  const prevUrl = localStorage.getItem("prevPage");
  const urlBreadcrumb = document.querySelector(".js-collection-url-breadcrumb");
  const localStorageItemAlreadyOnPage = urlBreadcrumb?.href?.indexOf(prevUrl) > -1;
  const mainCollectionToggle = (window.location.pathname === '/collections/women' || window.location.pathname === '/collections/men') && urlBreadcrumb.pathname !== prevUrl;
  if (document.referrer.indexOf(prevUrl) > -1 && !localStorageItemAlreadyOnPage && !mainCollectionToggle) {
    document.querySelector(".js-collection-breadcrumb a").href = prevUrl;
    document.querySelector(".js-collection-breadcrumb a").innerText = prevUrl.replaceAll("-", " ").replaceAll("collections", "").replaceAll("/", "");
    document.querySelector(".js-collection-breadcrumb").classList.remove("hidden");
  }
  localStorage.removeItem("prevPage");
}
